import { Store } from '@ngrx/store';
import { IAnnotationSearchableLink } from '../interfaces/annotation-searchable-links.interface';
import { ABERRATIONS_META_ACTIONS } from '../constants/aberrations-meta.constants';
import { Observable } from 'rxjs/Observable';
import { IgenomicsState } from '../../../core/interfaces/genomics-state.interface';
import { Injectable } from '@angular/core';

@Injectable()
export class AberrationsMetaActionCreatorService {

    private store$: Store<any>;
    constructor(store$: Store<IgenomicsState>) {
        this.store$ = store$.select('tests', 'aberrations', 'meta', 'config') as any;
    }



    setSearchableLinksConfig(key: string, config: IAnnotationSearchableLink): void {
        this.store$.dispatch({
            type: ABERRATIONS_META_ACTIONS.SET_SEARCH_LINK_CONFIG,
            payload: {
                searchId: key,
                config
            }
        });
    }

    getSearchableLinksConfig(key: string): Observable<{ key: string, data: Array<IAnnotationSearchableLink> | null }> {
        return this.store$.select('searchableLinks')
            .take(1)
            .map(data => {
                if (!data.has(key)) {
                    return { key, data: null };
                } else {
                    return { key, data: data.get(key) };
                }
            });
    }
}
